import moment from "moment";
import { DateTimeProvider } from "../Services/DateTimeProvider";


export class Throttle
{
    public static Throttle(lastCall: Date, delay: number, now: Date = DateTimeProvider.Now): boolean
    {
        return moment(lastCall).isBefore(moment(now).subtract(delay, "seconds"));
    }
}
